import ScannedProductInfo from './ScannedProductInfo';

export default function resolveScannableCodeFromProduct(info: ScannedProductInfo) {
  return info.product.scannableCodes.find(c => c.lookupCode === info.scannedCode.code);
}
